/** Eight cards each in both games: 3 + 2 before the auction, 3 after. */
export const BELOT_TRICKS_PER_HAND = 8;
export const BELOT_VALAT_BONUS = 90;
export const BELOT_LAST_TRICK = 10;
export const BELOT_BELOT_POINTS = 20;
export const DEFAULT_BELOT_CONFIG = { players: 4, target: 151, declarations: true };
/** Partial, forgiving merge, the same contract as the other games: any key
 *  left out keeps its default, so `{ players: 2 }` is a complete config. */
export function validateBelotConfig(raw) {
    if (raw === undefined || raw === null)
        return { ok: true, config: DEFAULT_BELOT_CONFIG };
    if (typeof raw !== 'object')
        return { ok: false, error: 'config must be an object' };
    const r = raw;
    const out = { ...DEFAULT_BELOT_CONFIG };
    const errors = [];
    if (r.players !== undefined) {
        if (r.players !== 2 && r.players !== 4)
            errors.push('players must be 2 or 4');
        else
            out.players = r.players;
    }
    if (r.target !== undefined) {
        const v = r.target;
        if (typeof v !== 'number' || !Number.isInteger(v) || v < 10 || v > 1000) {
            errors.push('target must be an integer in [10, 1000]');
        }
        else
            out.target = v;
    }
    if (r.declarations !== undefined) {
        if (typeof r.declarations !== 'boolean')
            errors.push('declarations must be a boolean');
        else
            out.declarations = r.declarations;
    }
    if (errors.length > 0)
        return { ok: false, error: errors.join('; ') };
    return { ok: true, config: out };
}
//# sourceMappingURL=config.js.map